export default __webpack_public_path__ + "static/media/error404_background.855ab5f6.jpg";